module.exports = __webpack_public_path__ + "static/media/logo.73943418.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 255
// module chunks = 0